<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="close"
    @keyup.enter.native="handleOk"
    cancelText="关闭">
    <dm-driver-label-form ref="realForm"  @ok="submitCallback"  :disabled="disableSubmit"></dm-driver-label-form>
  </j-modal>
</template>

<script>

  import DmDriverLabelForm from "./DmDriverLabelForm";
  export default {
    name: 'DmDriverLabelModal',
    components: {
      DmDriverLabelForm,
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
      }
    },
    methods: {
      add (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(record);
        })
      },
      edit (record) {
            this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();

      },
      submitCallback(){
        this.visible = false;
        this.$emit('ok');
      }
    }
  }
</script>